module.exports = __webpack_public_path__ + "static/media/moile-viewdecor1.20dad75b.png";